import axios from 'axios';

// Create axios instance with custom config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000, // 30 second timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Get the current API configuration
export const getCurrentApiConfig = () => {
  return {
    baseURL: api.defaults.baseURL,
    timeout: api.defaults.timeout
  };
};

// Set the API configuration (kept for compatibility)
export const setMongoConfig = (config) => {
  // Config is now handled by environment variables
  console.log('API configuration is now handled by environment variables');
};

export const fetchProjects = async () => {
  try {
    const response = await api.get('/api/appdata');
    return response.data;
  } catch (error) {
    // Error fetching projects
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timed out while fetching projects. Please try again.');
    }
    throw new Error(error.message || 'Failed to fetch projects');
  }
};

export const fetchRuns = async () => {
  try {
    const response = await api.get('/api/runs');
    return response.data;
  } catch (error) {
    // Error fetching runs
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timed out while fetching runs. Please try again.');
    }
    throw new Error(error.message || 'Failed to fetch runs');
  }
};

export const fetchProjectDetails = async (projectId) => {
  try {
    const response = await api.get(`/api/project/${projectId}`);
    return response.data;
  } catch (error) {
    // Error fetching project details
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timed out while fetching project details. Please try again.');
    }
    throw new Error(error.message || 'Failed to fetch project details');
  }
};

export const checkDatabaseStatus = async () => {
  try {
    const response = await api.get('/api/database_status', {
      timeout: 30000
    });
    return response.data;
  } catch (error) {
    // Error checking database status
    if (error.code === 'ECONNABORTED') {
      throw new Error('Connection timed out. Please check your network connection and try again.');
    }
    if (error.response?.status === 401) {
      throw new Error('Invalid database credentials. Please check your configuration.');
    }
    if (error.response?.status === 404) {
      throw new Error('Could not connect to the database server. Please verify the configuration.');
    }
    throw new Error(error.message || 'Failed to connect to database. Please check your configuration.');
  }
};

// Keep old function name for compatibility
export const checkMongoStatus = checkDatabaseStatus;

export const fetchTraces = async (traceIds, projectName, userId) => {
  try {
    const response = await api.post('/api/traces', {
      trace_ids: traceIds,
      project_name: projectName,
      user_id: userId
    });
    return response.data;
  } catch (error) {
    // Error fetching traces
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timed out while fetching traces. Please try again.');
    }
    throw new Error(error.message || 'Failed to fetch traces');
  }
};

 